module.exports = __webpack_public_path__ + "static/media/sre-bin.af290dff.svg";